import { React, useEffect, useContext, useState } from 'react';
import { useLocation } from "react-router-dom";
import './about.css';
import Header2 from '../../header2/index-two';
import { Footer2 } from '../../footer2';
import { Link } from 'react-router-dom';
import {
  idealMockup, logo, SolEntegrasyonlar, SagDRM, KareKultur,
  Ref1, Ref2, Ref3, Ref4, Ref5
} from '../../imagepath';
import axiosInstance from '../../../services/axiosInstance';
import { AppContext } from "../../../services/AuthContext";
import { getVizyonMisyon, getMarkalarveSeriler, getIkiliKart, getMockupText } from "../../../services/directusService";
import usePageTracking from "../../../hooks/usePageTracking";


const GreenSpinner = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100px' }}>
    <div className="spinner-border" role="status" style={{ color: '#14a076c0', width: '3rem', height: '3rem' }}>
      <span className="visually-hidden">Yükleniyor...</span>
    </div>
  </div>
);

const About = () => {
  usePageTracking("about-us");
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();
  const { auth } = useContext(AppContext);
  const [stats, setStats] = useState({
    journal: 0,
    book: 0,
    article: 0,
    other: 0
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  }, [pathname]);

  useEffect(() => {
    fetchStats();
  }, []);

  //FETCHLER

  const [visionMission, setVisionMission] = useState({
    mission_description: "<li>Güncel, güvenilir ve disiplinlerarası yayınları tek bir platformda erişilebilir kılmak.</li><li>Araştırmacılara ve öğrencilere keşif ve uygulama imkânı sunmak.</li><li>Açık erişim, saydamlık ve etik ilkeler üzerine kurulu bir veri yayım ekosistemi oluşturmak.</li><li>Etkiyi sadece atıf sayısıyla değil, gerçek dünyadaki katkılarla ölçmek.</li>",
    vision_description: "<li>Bilgiye erişimde sınırları kaldırmak.</li><li>Akademik, kurumsal ve toplumsal düzeyde gerçek etkisi olan çalışmaları desteklemek</li><li>Farklı seslerin duyulduğu, kapsayıcı ve sürdürülebilir bir bilgi ekosistemi inşa etmek.</li>"
  });

  const fetchVisionMission = async () => {
    try {
      const data = await getVizyonMisyon();
      const item = data?.data?.[0];

      if (item) {
        setVisionMission({
          mission_description: item.mission_description || "",
          vision_description: item.vision_description || ""
        });
      }

    } catch (err) {
      console.error("Vizyon/Misyon yüklenemedi:", err);
    }
  };

  const [markalarSeriler, setMarkalarSeriler] = useState({
    markalarList: [],
    kutuphanelerList: ["İdeal Kültür Akademi", "Dürbün Kitap", "Alkun Kitap", "Aktif Yayınevi"]
  })

  const fetchMarkalarveSeriler = async () => {
    try {
      const response = await getMarkalarveSeriler();
      const item = response?.data?.[0]
      if (item) {
        setMarkalarSeriler({
          markalarList: item.markalar || "",
          kutuphanelerList: item.kutuphaneler || ""
        });
        // console.log(markalarSeriler);
      }


    } catch (err) {
      //
    }
  }


  const [ikiliKart, setIkiliKart] = useState({
    title1: "",
    title2: "",
    description1: "",
    description2: "",
    etiketler1: [],
    etiketler2: [],
  })

  const fetchIkiliKart = async () => {
    try {
      const response = await getIkiliKart();
      const item = response?.data?.[0]
      // console.log(item.title)
      if (item) {
        setIkiliKart({
          title1: item.title || "",
          title2: item.title_2 || "",
          description1: item.description || "",
          description2: item.description_2 || "",
          etiketler1: item.etiketler_1 || [],
          etiketler2: item.etiketler_2 || [],
        });
        // console.log(ikiliKart);
      }

    } catch (err) {
      //
    }
  }

  const [mockupText, setMockupText] = useState("");

  const fetchMockupText = async () => {
    try {
      const response = await getMockupText();
      const item = response?.data?.[0];
      console.log(item)

      if (item) {
        setMockupText(item.content || "");
        console.log(mockupText);
      }
    } catch (err) {
      console.error("Mockup text yüklenemedi:", err);
    }
  };


  useEffect(() => {
    fetchVisionMission();
    fetchMarkalarveSeriler();
    fetchIkiliKart();
    fetchMockupText();
  }, []);

  const fetchStats = async () => {
    try {
      setLoading(true);   // --- BAŞTA SPINNER AÇ

      const headers = auth.token ? { Authorization: `Bearer ${auth.token}` } : {};

      // 1) Dergi toplamı
      const journalResp = await axiosInstance.post(
        "publicationSearch/AtoZJournalsCount",
        {
          databasename: [],
          searchkeyword: "",
          topicname: "",
          searchtype: ""
        },
        { headers }
      );

      const journal = journalResp.data?.data?.count || 0;

      // 2) Aggregation
      const aggrBody = {
        publicationAdvantageSearchDTOList: [
          { typename: "all", attributename: "", searchkeyword: "*", operator: "or" }
        ],
        permission: -1,
        databases: [],
        languages: [],
        documentTypes: [],
        keywords: [],
        publishers: [],
        topicTitles: [],
        startyear: "",
        endyear: "",
        journals: [],
        status: 1
      };

      const aggrResp = await axiosInstance.post(
        "publicationSearch/advantageAggrSearchElastic?page=1&newpagesize=20",
        aggrBody,
        { headers }
      );

      const root = aggrResp.data?.data ?? {};
      const types = root?.publicationTypes ?? [];

      const norm = (s = "") => s.toLocaleLowerCase("tr")
        .replaceAll("&", "ve")
        .replaceAll("ı", "i").replaceAll("ş", "s").replaceAll("ğ", "g")
        .replaceAll("ü", "u").replaceAll("ö", "o").replaceAll("ç", "c")
        .replace(/\s+/g, " ").trim();

      const countFrom = (arr = [], keys = []) => {
        const set = new Set(keys.map(norm));
        return arr.reduce(
          (sum, it) => sum + (set.has(norm(it?.key)) ? Number(it?.value || 0) : 0),
          0
        );
      };

      const book = countFrom(types, ["Akademik Kitap", "Popüler Kitap", "Populer Kitap"]);
      const article = countFrom(types, ["Akademik Makale"]);
      const totalTypes = types.reduce((sum, t) => sum + Number(t?.value || 0), 0);
      const other = totalTypes - article;

      setStats({ journal, book, article, other });

    } catch (e) {
      console.error("Error loading stats:", e);
    } finally {
      setLoading(false);   // --- SORGULAR TAMAMLANINCA SPINNER KAPAT
    }
  };



  return (
    <div className="main-wrapper" style={{ background: '#f8fafc', minHeight: '100vh' }}>
      <Header2 />

      {/* Hakkımızda Section */}
      <section className="about-header-section">
        <div className="about-header-container">
          <div className="about-header-background">
            <div className="about-header-content">
              <div className="about-header-title">
                <h2>Hakkımızda</h2>
              </div>
              <div className="about-header-description">
                İdealonline, İdeal Kültür Yayıncılık'ın dijital platformu olarak akademik ve kültürel bilgilere
                hızlı ve güvenli erişim sağlar.
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* İdealonline Tanıtım Section */}
      <section className="about-intro-section">
        <div className="about-intro-container">
          {/* Left: Görsel */}
          <div className="about-intro-left">
            <div className="about-intro-image">
              <img src={idealMockup} alt="İdealonline Mockup" />
            </div>
          </div>

          {/* Right: Metin */}
          <div className="about-intro-right">
            <div className="about-intro-content">
              <div className="about-intro-logo">
                <img src={logo} alt="İdealonline Logo" />
              </div>

              <div
                className="about-intro-text"
                dangerouslySetInnerHTML={{ __html: mockupText }}
              />

            </div>
          </div>
        </div>
      </section>

      {/* Entegrasyon ve DRM kartları */}
      <section className="about-section">
        <div className="about-container">
          {/* ---- SOL KART: ULUSLARARASI GÖRÜNÜRLÜK (Directus) ---- */}
          <div className="about-card bordered-card">
            <div className="about-card-image">
              <img src={SolEntegrasyonlar} alt={ikiliKart.title1} />
            </div>

            <div className="about-card-content">
              <h3 className="about-heading">{ikiliKart.title1}</h3>

              <p
                className="about-text"
                dangerouslySetInnerHTML={{ __html: ikiliKart.description1 }}
              />

              <div className="about-tags">
                {ikiliKart.etiketler1?.map((tag, index) => (
                  <span key={index}>{tag}</span>
                ))}
              </div>
            </div>
          </div>

          {/* ---- SAĞ KART: DRM GÜVENLİK (Directus) ---- */}
          <div className="about-card gray-card">
            <div className="about-card-image">
              <img src={SagDRM} alt={ikiliKart.title2} />
            </div>

            <div className="about-card-content">
              <h3 className="about-heading">{ikiliKart.title2}</h3>

              <p
                className="about-text"
                dangerouslySetInnerHTML={{ __html: ikiliKart.description2 }}
              />

              <div className="about-tags">
                {ikiliKart.etiketler2?.map((tag, index) => (
                  <span key={index}>{tag}</span>
                ))}
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* İstatistikler */}
      <section className="about-stats-section">
        <div className="about-stats-container">
          <div className="about-stats-header">
            <h2>Binlerce Kaynak, Tek Platform</h2>
            <p>
              Her geçen gün büyüyen arşivimizle, akademik çalışmalarınız için
              güvenilir kaynaklara kolayca ulaşabilirsiniz.
            </p>
          </div>

          <div className="about-stats-cards">
            {loading ? (
              <GreenSpinner />
            ) : (
              <>
                <div className="about-stat-card">
                  <h3><span className="number">{stats.journal.toLocaleString()}+</span></h3>
                  <p>Dergi</p>
                </div>

                <div className="about-stat-card">
                  <h3><span className="number">{stats.book.toLocaleString()}+</span></h3>
                  <p>Kitap</p>
                </div>

                <div className="about-stat-card">
                  <h3><span className="number">{stats.article.toLocaleString()}+</span></h3>
                  <p>Makale</p>
                </div>

                <div className="about-stat-card">
                  <h3><span className="number">{stats.other.toLocaleString()}+</span></h3>
                  <p>Diğer</p>
                </div>
              </>
            )}
          </div>

        </div>
      </section>

      {/* Vizyon & Misyon */}
      <section className="about-vision-mission-section">
        <div className="about-vision-mission-container">
          <div className="about-vision-mission-header">
            <h2>Hedefimiz ve Yol Haritamız</h2>
            <p>
              İdealonline, bilgiye güvenilir ve sürdürülebilir erişim sağlama
              hedefiyle yol almaktadır.
            </p>
          </div>

          <div className="about-vision-mission-cards">
            {/* Vizyon Kartı */}
            <div className="vision-card">
              <h3>Vizyonumuz</h3>
              <ul
                dangerouslySetInnerHTML={{ __html: visionMission.vision_description }}
              />
            </div>


            {/* Misyon Kartı */}
            <div className="mission-card">
              <h3>Misyonumuz</h3>
              <ul
                dangerouslySetInnerHTML={{ __html: visionMission.mission_description }}
              />
            </div>

          </div>
        </div>
      </section>

      {/* Partner Section */}
      <section className="about-partner-section">
        <div className="about-partner-container">
          <h3 className="partner-subtitle">— PARTNER KURULUŞUMUZ</h3>

          <div className="partner-content">
            {/* Sol kolon */}
            <div className="partner-left">
              <h2>İdeal Kültür Yayıncılık</h2>

              <p>
                <strong>İdeal Kültür Yayıncılık</strong>, 2008'de yayın hayatına başlamış,
                <strong> 2011'den itibaren Uluslararası Yayınevi</strong> statüsünde faaliyet göstermektedir.
              </p>

              <p>
                Türkçe dışı <strong>20+ yayın</strong> üreten yayınevi,
                <strong> 17 Ocak 2020</strong> tarihli Resmî Gazete değişikliğiyle
                "<strong>Tanınmış Uluslararası Yayınevi</strong>" statüsünü taşımakta ve
                <strong> Web of Science: Book Citation Index (BKCI)</strong>'de dizinlenmektedir.
              </p>

              <p>
                <strong>2024 Aralık</strong> itibarıyla, alt markalarıyla birlikte
                <strong> 700'ü aşkın eser</strong> yayımlamış; bunların birçoğu
                <em> yurtdışındaki kütüphanelerde</em> kataloglanmıştır.
              </p>

              <div className="partner-timeline">
                <div className="timeline-item"><div className="year-box">2008</div><div className="dot" /><div className="label">Yayın Hayatı Başladı</div></div>
                <div className="timeline-item"><div className="year-box">2011</div><div className="dot" /><div className="label">Uluslararası Statü</div></div>
                <div className="timeline-item"><div className="year-box">2020</div><div className="dot" /><div className="label">Tanınmış Yayınevi</div></div>
                <div className="timeline-item"><div className="year-box">2024</div><div className="dot" /><div className="label">700+ Eser</div></div>
              </div>

              <div className="partner-highlight-box">
                <strong>İdealonline</strong>, Türkiye ve Türk Dünyası'ndaki akademik ve kültürel bilgi kaynaklarını
                dijital olarak sunan bir <strong>İdeal Kültür kuruluşudur.</strong>
              </div>

              <p className="partner-bottom-text">
                Yayınevi ayrıca üniversiteler, kolejler ve diğer kamu-özel kurumların kitap ve bilgi ihtiyacına
                hizmet sunmaktadır. <strong>Kütüphane kurulumu</strong>, <strong>LC ve Dewey kataloglama</strong> ile
                <strong> dergi abonelikleri</strong> gibi hizmetlerle bilgi kaynaklarına erişimi desteklemektedir.
              </p>
            </div>

            {/* Sağ kolon */}
            <div className="partner-right">
              <h2 className='text-center'>Markalarımız & Serilerimiz</h2>
              <p>İdeal Kültür Yayıncılık bünyesinde öne çıkan markalar ve seriler:</p>

              <div className="brand-logo">
                <img src={KareKultur} alt="İdeal Kültür Logo" />
              </div>

              <div className="brand-tags">
                {markalarSeriler.markalarList.map((marka, i) => (
                  <span key={i}>{marka}</span>
                ))}
              </div>

              <h4 className="catalog-header">Seçkin kütüphanelerde kataloglanan eserler;</h4>
              <ul className="library-list">
                {markalarSeriler.kutuphanelerList.map((kutuphane, i) => (
                  <li key={i}>{kutuphane}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Referanslar */}
      <section className="about-references-section">
        <div className="references-container">
          <div className="references-left">
            <h2>Referanslarımız</h2>
            <p>
              İdealonline, güçlü altyapısı ve güvenilir yayın politikası sayesinde
              birçok kurum, kütüphane ve üniversite tarafından tercih edilmektedir.
            </p>
            <Link to="/references" className="references-link">Tümünü Gör</Link>
          </div>

          <div className="references-right">
            <div className="university-logos">
              <div className="uni-logo"><img src={Ref1} alt="Ege Üniversitesi" /></div>
              <div className="uni-logo"><img src={Ref2} alt="Gazi Üniversitesi" /></div>
              <div className="uni-logo"><img src={Ref3} alt="İstanbul Üniversitesi" /></div>
              <div className="uni-logo"><img src={Ref4} alt="Marmara Üniversitesi" /></div>
              <div className="uni-logo"><img src={Ref5} alt="Bursa Uludağ Üniversitesi" /></div>
            </div>
          </div>
        </div>
      </section>
      <Footer2 />
    </div>
  );
};

export default About;